export var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
